import Loadable from '../../components/loadable';

const BulkCancelMemberships = Loadable({
  loader: () => import('../../pages/reports/bulk_cancel_memberships/index'),
});

angular.module('gym').value('BulkCancelMemberships', BulkCancelMemberships);

const BulkCancelMembershipsFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/bulk_cancel_memberships/bulk_cancel_memberships_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkCancelMembershipsFiltersModal', BulkCancelMembershipsFiltersModal);

const BulkCancelMembershipsModal = Loadable({
  loader: () => import('../../pages/reports/bulk_cancel_memberships/bulk_cancel_memberships_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkCancelMembershipsModal', BulkCancelMembershipsModal);
